// Giá lưu dạng numeric (chuỗi) để không mất chính xác khi cộng đơn hàng; mọi
// chỗ hiển thị đi qua đây nên định dạng tiền chỉ có MỘT nơi để sửa.
export function toNumber(value: string | number | null | undefined): number {
  if (value === null || value === undefined) return 0
  const n = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(n) ? n : 0
}

export function formatPrice(value: string | number | null | undefined): string {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    maximumFractionDigits: 0,
  }).format(toNumber(value))
}
